import createParseMiddleware from './createParseMiddleware';
import { parseDenyReasonResponse, parseDenyEntryResponse } from 'utils/apiParser/denyParser';
import { DenyReason, DenyEntry } from 'types/denyTypes';

export const parseFetchDenyReasonsMiddleware = createParseMiddleware<DenyReason>(parseDenyReasonResponse, 'deny/fetchDenyReasons');
export const parseDescribeDenyReasonMiddleware = createParseMiddleware<DenyReason>(parseDenyReasonResponse, 'deny/describeDenyReason');
export const parseDescribeDeniedEntryMiddleware = createParseMiddleware<DenyEntry>(parseDenyEntryResponse, 'deny/describeDeniedEntry');
